import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { SoundContextProvider } from "./context/index.jsx";
import Angie from "../../utils/angie.jsx";

// eslint-disable-next-line compat/compat
const AudioContext = window.AudioContext || window.webkitAudioContext;

export const SoundProvider = ({ children }) => {
  const context = useMemo(() => {
    if (!Angie.audioContext) {
      Angie.audioContext = new AudioContext();
    }
    return Angie.audioContext;
  }, []);

  const preloadSound = useCallback(
    (url) => {
      if (!Angie.sounds) {
        Angie.sounds = {};
      }

      if (typeof Angie.sounds[url] === "undefined") {
        Angie.sounds[url] = null;
        const request = new XMLHttpRequest();

        request.open("GET", url, true);
        request.responseType = "arraybuffer";

        request.onload = function () {
          const undecodedAudio = request.response;

          context.decodeAudioData(undecodedAudio, (buffer) => {
            Angie.sounds[url] = buffer;
          });
        };

        request.send();
      }
    },
    [context]
  );

  const handlePlay = useCallback(
    (url) => {
      const buffer = Angie.sounds[url];

      if (buffer) {
        const sourceBuffer = context.createBufferSource();
        sourceBuffer.buffer = buffer;
        sourceBuffer.connect(context.destination);
        sourceBuffer.start(context.currentTime);
      }
    },
    [context]
  );

  return <SoundContextProvider value={{ play: handlePlay, preloadSound }}>{children}</SoundContextProvider>;
};

SoundProvider.propTypes = {
  children: PropTypes.node,
};
